import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http'
import { ResourceService } from '@smartsoftware/reflex-core';
import { SequenceOrderStep } from '../models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class SequenceOrderStep_Service extends ResourceService<SequenceOrderStep> {
    protected servicePath: string = '/SequenceOrderStep';

    public ModelType = SequenceOrderStep;
    
    constructor(
        protected http: HttpClient
    ) {
        super(http);
    }
    

    public getSequenceOrderForOrder(uuid:string): Observable<any> {
        return this.http
        .post(
            this.serviceUrl + 'getSequenceOrderForOrder',
            {
                uuid:uuid
            },
            {
                observe: 'response'
            }
        )
        .pipe(
            map(
                (response: HttpResponse<any>) => {
                    return response.body;
                }
            )
        );
    }

}
